import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Unit } from '@/types';
import { useCreateUnitMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateUnitProps extends DialogProps {
  onClose(): void;
}

const CreateUnit: React.FC<CreateUnitProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createUnit, createUnitResponse] = useCreateUnitMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Unit>({
    initialValues: {
      buro_code: '',
      code: '',
      name: '',
    },
    validationSchema: yup.object().shape({
      buro_code: yup.string().required(messages.form.REQUIRED),
      code: yup.string().required(messages.form.REQUIRED),
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(unit, { resetForm }) {
      try {
        await createUnit(unit).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить единицу измерения</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="buro_code"
                label="Код бюро"
                placeholder="Введите значение"
                value={values.buro_code}
                onChange={handleChange}
                disabled={createUnitResponse.isLoading}
                error={touched.buro_code && Boolean(errors.buro_code)}
                helperText={touched.buro_code ? errors.buro_code : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="code"
                label="Код"
                placeholder="Введите значение"
                value={values.code}
                onChange={handleChange}
                disabled={createUnitResponse.isLoading}
                error={touched.code && Boolean(errors.code)}
                helperText={touched.code ? errors.code : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createUnitResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={createUnitResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={createUnitResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateUnit;
